<template>
  <div class="position-relative">
    <d-card-header class="border-bottom flex-header">
      <div class="d-flex flex-column">
        <h6 class="m-0">Rozbicie nadpłaty</h6>
        <small>Nadpłata: <strong>{{overpayment}} zł</strong></small>
        <small>Suma rozbić nadpłaty:
          <strong
            :class="{
              'text-danger': overpayment !== overpaymentSettlementsSum,
              'text-success': overpayment === overpaymentSettlementsSum
            }">
            {{overpaymentSettlementsSum}} zł
          </strong>
        </small>
      </div>
      <d-button
        theme="primary"
        @click.prevent="showSettlementForm(null)">
        <i class="material-icons">add</i>Dodaj robicie nadpłaty
      </d-button>
    </d-card-header>
    <d-card-body class="p-0 pb-3 text-center">
      <div
          v-if="!overpaymentSettlementsLoaded"
          class="overlay-loading">
          <h2 class="preloader isLoading position-absolute">Trwa ładowanie</h2>
      </div>
      <table class="table mb-0 responsive-table">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0 id-cell">Kwota</th>
            <th scope="col" class="border-0 id-cell">Data realizacji</th>
            <th scope="col" class="border-0 id-cell">Akcje</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(settlement, index) in overpaymentSettlements"
            :key="'settlement-item-' + index">
            <td>
              <dt>Kwota</dt>
              <dd>{{ settlement.amount}} zł</dd>
            </td>
            <td>
              <dt>Data realizacji</dt>
              <dd>{{ settlement.date || 'brak'}}</dd>
            </td>
            <td>
              <dt>Akcje</dt>
              <dd>
                <d-button
                  @click.prevent="editItem(settlement)"
                  class="mr-1 mr-3"
                  :disabled="actionInProgress">
                  <i class="material-icons">edit</i> Edytuj
                </d-button>
                <d-button
                  @click.prevent="removeItem(settlement)"
                  theme="danger"
                  class="mr-1 mr-3"
                  :disabled="actionInProgress">
                  <i class="material-icons">delete</i> Usuń
                </d-button>
              </dd>
            </td>
          </tr>
          <tr v-if="overpaymentSettlements.length === 0">
            <td
              :colspan="3"
              class="text-center text-info">
              Brak rozbić nadpłaty do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>
    </d-card-body>
    <overpayment-settlement-modal
      :close-callback="closeSettlementForm"
      :schedule-id="scheduleId"
      :selected-settlement="selectedSettlement"
      :show.sync="isSettlementFormVisible" />
  </div>
</template>

<script>
import Vue from 'vue';
import OverpaymentSettlementModal from '@/components/client/contract-partials/OverpaymentSettlementModal.vue';
import ListUtils from '@/utils/ListUtils.js';

export default {
  name: 'ContractOverpayment',
  components: {
    OverpaymentSettlementModal
  },
  props: {
    scheduleId: {
      type: Number,
      required: true
    },
    overpayment: {
      type: Number,
      required: true
    },
    overpaymentSettlements: {
      type: Array,
      default: []
    },
    overpaymentSettlementsLoaded: {
      type: Boolean,
      default: false
    },
    overpaymentSettlementsSum: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      selectedSettlement: null,
      isSettlementFormVisible: false,
      loaded: false,
      loadError: false,
      actionInProgress: false
    }
  },
  mounted () {
  },
  methods: {
    showSettlementForm (settlement = null) {
      Vue.set(this, 'selectedSettlement', settlement);
      this.$nextTick(() => {
        Vue.set(this, 'isSettlementFormVisible', true);
      });
    },
    closeSettlementForm (shouldReload = false) {
      Vue.set(this, 'isSettlementFormVisible', false);

      if (shouldReload) {
        this.$bus.$emit('reload-overpayment-settlements');
      }
    },
    editItem (settlement) {
      this.showSettlementForm(settlement);
    },
    removeItem (settlement) {
      this.actionInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/api/overpayment-settlement/delete/' + settlement.id,
        id: null,
        successTitle: 'Rozliczenie zostało usunięte',
        successText: '',
        confirmTitle: 'Uwaga',
        confirmText: 'Czy potwierdzasz usunięcie rozliczenia?',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie rozliczenia nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
            this.actionInProgress = false;
            this.$bus.$emit('reload-overpayment-settlements');
        },
        cancelAction: () => {
            this.actionInProgress = false;
        },
      });
    }
  }
}
</script>